/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationObligationProcessesQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationObligationProcessesInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalRegulationObligationProcessesQuery = {
  __typename?: 'Query';
  internalRegulationObligationProcesses: {
    __typename: 'InternalRegulationObligationProcessConnection';
    edges: Array<{
      __typename: 'InternalRegulationObligationProcessEdge';
      cursor: string;
      node: {
        __typename: 'InternalRegulationObligationProcess';
        id: string;
        processCode?: string | null;
        processName?: string | null;
        processDescription?: string | null;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalRegulationObligationProcessesDocument = gql`
  query InternalRegulationObligationProcesses(
    $input: InternalRegulationObligationProcessesInput
    $first: Int
    $after: String
  ) {
    internalRegulationObligationProcesses(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          processCode
          processName
          processDescription
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalRegulationObligationProcessesQuery__
 *
 * To run a query within a React component, call `useInternalRegulationObligationProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationObligationProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationObligationProcessesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalRegulationObligationProcessesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IInternalRegulationObligationProcessesQuery,
    IInternalRegulationObligationProcessesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IInternalRegulationObligationProcessesQuery,
    IInternalRegulationObligationProcessesQueryVariables
  >(InternalRegulationObligationProcessesDocument, options);
}
export function useInternalRegulationObligationProcessesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalRegulationObligationProcessesQuery,
    IInternalRegulationObligationProcessesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IInternalRegulationObligationProcessesQuery,
    IInternalRegulationObligationProcessesQueryVariables
  >(InternalRegulationObligationProcessesDocument, options);
}
// @ts-ignore
export function useInternalRegulationObligationProcessesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalRegulationObligationProcessesQuery,
    IInternalRegulationObligationProcessesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationProcessesQuery,
  IInternalRegulationObligationProcessesQueryVariables
>;
export function useInternalRegulationObligationProcessesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationProcessesQuery,
        IInternalRegulationObligationProcessesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationProcessesQuery | undefined,
  IInternalRegulationObligationProcessesQueryVariables
>;
export function useInternalRegulationObligationProcessesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationProcessesQuery,
        IInternalRegulationObligationProcessesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IInternalRegulationObligationProcessesQuery,
    IInternalRegulationObligationProcessesQueryVariables
  >(InternalRegulationObligationProcessesDocument, options);
}
export type InternalRegulationObligationProcessesQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationProcessesQuery
>;
export type InternalRegulationObligationProcessesLazyQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationProcessesLazyQuery
>;
export type InternalRegulationObligationProcessesSuspenseQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationProcessesSuspenseQuery
>;
export type InternalRegulationObligationProcessesQueryResult = Apollo.QueryResult<
  IInternalRegulationObligationProcessesQuery,
  IInternalRegulationObligationProcessesQueryVariables
>;
